import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito conocimientos previos?',
  a: 'No. La formación está diseñada para llevarte desde cero absoluto hasta un nivel profesional.'
}, {
  q: '¿Tiene horarios?',
  a: 'No. Al ser material 100% digital, puedes estudiar a tu propio ritmo y en tus propios horarios.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Todo el contenido es digital para que puedas acceder desde cualquier dispositivo.'
}, {
  q: '¿Está en PDF?',
  a: 'Sí. Los tomos y bonos están en formato PDF de alta calidad, listos para leer o imprimir.'
}, {
  q: '¿Obtengo certificado?',
  a: 'Sí. Al finalizar tu estudio, obtendrás un certificado digital que avala tus conocimientos.'
}, {
  q: '¿El acceso es para siempre?',
  a: 'Sí. Una vez que adquieres la formación, el acceso es de por vida, incluyendo futuras actualizaciones del material.'
}, {
  q: '¿Puedo descargar el material?',
  a: 'Sí. Puedes descargar todos los PDFs a tus dispositivos para estudiar sin conexión a internet.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 relative z-10" data-id="element-108">
      <div className="container mx-auto px-4" data-id="element-109">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-111">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-112"></div>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-113">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          y: 10
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-mystic-800 border border-mystic-700 rounded-xl overflow-hidden" data-id="element-114">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-mystic-700/50 transition-colors" data-id="element-115">
                <span className="font-medium text-white/90" data-id="element-116">{faq.q}</span>
                <ChevronDown className={`text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-117" />
              </button>
              <AnimatePresence data-id="element-118">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-119">
                    <div className="px-6 pb-4 pt-2 text-white/70 border-t border-mystic-700 mx-6 mt-2" data-id="element-120">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}